import React, { useState, useEffect } from 'react';
import { AuditHistoryRequest } from '../models/audit-history-request';
import { Entity } from '../models/entity';
import { Entities, MessageBoxReplyType } from '../models/enums';
import { DatabaseHistoryRow } from '../models/Auditing/database-history-row';
import { AuditHistoryDisplay } from '../models/Auditing/audit-history-display';
import { CrudFunctions } from '../utilities/crud-functions';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';
import GlobalDialog from './Modal/GlobalDialog';

import DataGrid, {
    Column,
    Selection,
    Paging,
    Pager,
    Export,
    Item as ToolbarItem,
    Toolbar,
    GroupPanel,
    SearchPanel,
    HeaderFilter,
    FilterRow,
    Scrolling,
    FilterPanel,
    FilterBuilderPopup,
    Position,
    LoadPanel
} from 'devextreme-react/data-grid';

import {
    TextBox,
    SelectBox
} from 'devextreme-react';

import { Button } from 'devextreme-react/button';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { MessageBoxReply } from '../models/message-box-reply';

export default function AuditHistory() {
    const [entities, setEntities] =
        useState<Entity[]>();

    const [entity, setEntity] =
        useState<Entity>();

    const [auditHistory, setAuditHistory] =
        useState<AuditHistoryDisplay[]>();

    const [searchRowPointer, setSearchRowPointer] =
        useState<string>();

    const [searchName, setSearchName] =
        useState<string>();

    const [searchIdLabel, setSearchIdLabel] =
        useState<string>();

    const [searchNameLabel, setSearchNameLabel] =
        useState<string>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    useEffect(() => {
        getAllData();
    }, []);

    useEffect(() => {
        setSearchLabels();
    }, [entity]);

    return (
        <div className="pw-form-container">
            <div className="lq-title-bar">
                <div className="lq-main-title">Audit Data Search</div>
                <div className="title-bar-spacer" />
            </div>

            <div className="pw-comp-row">
                <div className="pw-form-unit pw-comp-20">
                    <label className="textbox-label">Entity</label>
                    <SelectBox
                        dataSource={entities ? entities : []}
                        onValueChanged={onEntitySelectionChanged}
                        displayExpr='label'
                        value={entity ? entity : undefined} />

                </div>
            </div>

            <div className="pw-comp-row">
                <div className="pw-form-unit pw-comp-20">
                    <label className="textbox-label">{searchIdLabel ? searchIdLabel : 'Entity Row Pointer'}</label>
                    <TextBox id="searchId" className="textbox"
                        showClearButton={true}
                        placeholder="search id"
                        onValueChanged={(e: any) => setSearchRowPointer(e.value)}
                        value={searchRowPointer ? searchRowPointer : undefined} />
                </div>

                <div className="pw-form-unit pw-comp-20">
                    <label className="textbox-label">{searchNameLabel ? searchNameLabel : 'Entity Name'}</label>
                    <TextBox id="searchName" className="textbox"
                        showClearButton={true}
                        placeholder="search name"
                        onValueChanged={(e: any) => setSearchName(e.value)}
                        value={searchName ? searchName : undefined} />
                </div>
                <Button id="searchButton" text="Search" icon="find" type="success"
                    hint="search"
                    height={'2.2em'}
                    className="pw-row-button-2"
                    onClick={onGetUpdatesClick} />
            </div>

            {auditHistory && auditHistory.map((ah) =>
                <div className="pw-comp-row" key={`image_${ah.id}`}>
                    <DataGrid
                        height="25rem"
                        dataSource={ah.dataset}
                        onExporting={onExporting}
                        showBorders={true}>

                        <LoadPanel enabled={true} />
                        <Selection mode='none' />
                        <HeaderFilter visible={true} />
                        <FilterRow visible={true} />
                        <GroupPanel visible={true} />
                        <SearchPanel visible={true} />
                        <FilterPanel visible={true} />
                        <FilterBuilderPopup>
                            <Position of={window} at='center' my='center' />
                        </FilterBuilderPopup>
                        <Scrolling rowRenderingMode='virtual' />
                        <Paging defaultPageSize={100} />
                        <Pager
                            visible={true}
                            allowedPageSizes={[10, 50, "all"]}
                            showPageSizeSelector={true}
                            showInfo={true}
                            showNavigationButtons={true} />
                        <Selection mode='single' />
                        <Export enabled={true} allowExportSelectedData={true} />

                        <Column dataField='modifyUser' width='10rem' />
                        <Column dataField='fieldName' width='10rem' />
                        <Column dataField='modifyTimestamp' width='10rem'
                            dataType="date" format="MM/dd/yyyy hh:mm:ss" />
                        <Column dataField='operation' width='6rem' />

                        {ah.includesRowIdentifier &&
                            <Column dataField='rowIdentifier' caption={ah.rowIdentifierLabel}
                                width={ah.rowIdentifierColumnWidth ? ah.rowIdentifierColumnWidth : '12rem'} />
                        }

                        <Column dataField='value' width={ah.valueColumnWidth ? ah.valueColumnWidth : "20rem"} />

                        {ah.includesEnumValue &&
                            <Column dataField='enumValue' caption={ah.enumValueLabel}
                                width={ah.enumValueColumnWidth ? ah.enumValueColumnWidth : "20rem"} />
                        }

                        <Column dataField='rowPointer' width="16rem" />
                        <Column />

                        <Toolbar>
                            <ToolbarItem location='before'>
                                <div className="pw-datagrid-toolbar-template">
                                    <div className="pw-datagrid-toobar-title">{ah.title}</div>
                                </div>
                            </ToolbarItem>
                            <ToolbarItem name="groupPanel" location='after' />
                            <ToolbarItem name="exportButton" location='after' />
                            <ToolbarItem name="searchPanel" location='after' />
                        </Toolbar>
                    </DataGrid>
                </div>
            )}

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata}
                onReply={onGlobalDialogReply} />
            }

        </div>
    );

    function onGlobalDialogReply(reply: MessageBoxReply) {
        console.log("onGlobalDialogReply:");
        console.log(reply);

        if (reply.reply === MessageBoxReplyType.Ok)
            hideGlobalDialog();
    }

    //exporting

    function onExporting(e: any) {
        const name = "DMA Audit Log";

        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');

        exportDataGrid({
            component: e.component,
            worksheet,
            autoFilterEnabled: true,
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${name}.xlsx`);
            });
        });

        e.cancel = true;
    }

    function onEntitySelectionChanged(e: any) {
        if (e.value && e.value.entityId && entities) {
            const entityId = e.value.entityId;

            const selectedEntity =
                entities.filter(ent => ent.entityId === entityId);

            console.log("selectedEntityXCX:");
            console.log(selectedEntity);

            if (selectedEntity && selectedEntity.length > 0) {
                setEntity(selectedEntity[0]);
            }
        }
    }

    async function onGetUpdatesClick() {
        if (!entity) {
            showReplyBox(ModalMessageType.PromptOk,
                "Entity Required", "You must first select an entity type.");

            return;
        }

        if (!searchRowPointer && !searchName) {
            showReplyBox(ModalMessageType.PromptOk,
                "Search Parameters Required", "You must first enter at least one search parameter.");

            return;
        }
        
        switch (entity.name) {
            case "Products":
                getProductHistory();
                break;

            case "RawMaterials":
                getRawMaterialHistory();
                break;

            case "BatchPlanning":
                getBatchPlanningHistory();
                break;

            case "BatchProductions":
                getBatchProductionHistory();
                break;
        }
    }

    async function getProductHistory() {
        let request: AuditHistoryRequest = {
            entityId: entity.entityId,
            //rowPointer: searchId 
            rowPointer: 'dab37166-b310-42ae-9b8c-c38dd74b92a5'
        };

        await getProductUpdates(request)
            .then((data) => {
                console.log("AUDITING - getProductUpdates()");
                console.log(data);

                //temp
                if (data) {
                    let auditHistoryData: AuditHistoryDisplay[] = [];

                    auditHistoryData.push({
                        id: 1,
                        dataset: data.products,
                        title: "Products",
                        includesEnumValue: true,
                        enumValueLabel: "Enum Value",
                        includesRowIdentifier: false,
                        valueColumnWidth: "25rem",
                        enumValueColumnWidth: "10rem"
                    });
                    auditHistoryData.push({
                        id: 4,
                        dataset: data.compositions,
                        title: "Compositions",
                        includesEnumValue: false,
                        includesRowIdentifier: true,
                        rowIdentifierLabel: "Raw Material",
                        rowIdentifierColumnWidth: "20rem"
                    });
                    auditHistoryData.push({
                        id: 5,
                        dataset: data.packagingMaterials,
                        title: "Packaging Materials",
                        includesEnumValue: false,
                        includesRowIdentifier: true,
                        rowIdentifierLabel: "Raw Material",
                        rowIdentifierColumnWidth: "20rem"
                    });
                    auditHistoryData.push({
                        id: 6,
                        dataset: data.standards,
                        title: "Products Standards",
                        includesEnumValue: false,
                        includesRowIdentifier: true,
                        rowIdentifierLabel: "Label"
                    });
                    auditHistoryData.push({
                        id: 7,
                        dataset: data.analyticalPlans,
                        title: "Analytical Plans",
                        includesEnumValue: false,
                        includesRowIdentifier: true,
                        rowIdentifierLabel: "Label"
                    });
                    auditHistoryData.push({
                        id: 8,
                        dataset: data.analyticalPlanAnalysisTypes,
                        title: "Analytical Plan Analysis Types",
                        includesEnumValue: false,
                        includesRowIdentifier: true,
                        rowIdentifierLabel: "Label"
                    });
                    auditHistoryData.push({
                        id: 9,
                        dataset: data.analyticalPlanBasisTypes,
                        title: "Analytical Plan Basis Types",
                        includesEnumValue: false,
                        includesRowIdentifier: true,
                        rowIdentifierLabel: "Label"
                    });
                    auditHistoryData.push({
                        id: 10,
                        dataset: data.analyticalPlanStandards,
                        title: "Analytical Plan Standards",
                        includesEnumValue: false,
                        includesRowIdentifier: true,
                        rowIdentifierLabel: "Label"
                    });

                    setAuditHistory(auditHistoryData);
                }
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error retrieving Product Auditing Information");
            });
    }

    async function getRawMaterialHistory() {
        let request: AuditHistoryRequest = {
            entityId: entity.entityId,
            rowPointer: searchRowPointer, // '44e88a1f-eb52-42f2-874e-04383cf4c960'
            entityName: searchName
        };

        await getRawMaterialUpdates(request)
            .then((data) => {
                console.log("AUDITING - getRawMaterialUpdates()");
                console.log(data);

                //temp
                if (data) {
                    let auditHistoryData: AuditHistoryDisplay[] = [];

                    auditHistoryData.push({
                        id: 1,
                        dataset: data.rawMaterials,
                        title: "Raw Materials",
                        includesEnumValue: true,
                        enumValueLabel: "Storage",
                        includesRowIdentifier: false,
                        valueColumnWidth: "25rem",
                        enumValueColumnWidth: "10rem"
                    });
                    auditHistoryData.push({
                        id: 2,
                        dataset: data.rawMaterialBatches,
                        title: "Raw Material Batches",
                        includesEnumValue: true,
                        enumValueLabel: "Storage",
                        includesRowIdentifier: true,
                        valueColumnWidth: "25rem",
                        enumValueColumnWidth: "12rem",
                        rowIdentifierLabel: "Batch Name",
                        rowIdentifierColumnWidth: "12rem"
                    });

                    setAuditHistory(auditHistoryData);
                }
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error retrieving Raw Material Auditing Information");
            });
    }

    async function getBatchPlanningHistory() {
        let request: AuditHistoryRequest = {
            entityId: entity.entityId,
            rowPointer: searchRowPointer, // 'E64C53B0-2C05-43E4-B915-65D2AB71C92D'
            entityName: searchName
        };

        await getBatchPlanningUpdates(request)
            .then((data) => {
                console.log("AUDITING - getBatchPlanningUpdates()");
                console.log(data);

                //temp
                if (data) {
                    let auditHistoryData: AuditHistoryDisplay[] = [];

                    auditHistoryData.push({
                        id: 1,
                        dataset: data.batchPlans,
                        title: "Batch Plans",
                        //includesEnumValue: true,
                        //enumValueLabel: "Storage",
                        //includesRowIdentifier: false,
                        valueColumnWidth: "25rem",
                        //enumValueColumnWidth: "10rem"
                    });
                    auditHistoryData.push({
                        id: 2,
                        dataset: data.batchStandards,
                        title: "Batch Standards",
                        //includesEnumValue: true,
                        //enumValueLabel: "Storage",
                        //includesRowIdentifier: true,
                        valueColumnWidth: "25rem",
                        //enumValueColumnWidth: "12rem",
                        //rowIdentifierLabel: "Batch Name",
                        //rowIdentifierColumnWidth: "12rem"
                    });

                    setAuditHistory(auditHistoryData);
                }
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error retrieving Raw Material Auditing Information");
            });
    }

    async function getBatchProductionHistory() {
        let request: AuditHistoryRequest = {
            entityId: entity.entityId,
            rowPointer: searchRowPointer, // 'E64C53B0-2C05-43E4-B915-65D2AB71C92D'
            entityName: searchName
        };

        await getBatchProductionUpdates(request)
            .then((data) => {
                console.log("AUDITING - getBatchProductionUpdates()");
                console.log(data);

                //temp
                if (data) {
                    let auditHistoryData: AuditHistoryDisplay[] = [];

                    auditHistoryData.push({
                        id: 1,
                        dataset: data.batchProductions,
                        title: "Batch Productions",
                        //includesEnumValue: true,
                        //enumValueLabel: "Storage",
                        //includesRowIdentifier: false,
                        valueColumnWidth: "25rem",
                        //enumValueColumnWidth: "10rem"
                    });
                    auditHistoryData.push({
                        id: 2,
                        dataset: data.checkWeights,
                        title: "Check Weights",
                        //includesEnumValue: true,
                        //enumValueLabel: "Storage",
                        //includesRowIdentifier: true,
                        valueColumnWidth: "25rem",
                        //enumValueColumnWidth: "12rem",
                        //rowIdentifierLabel: "Batch Name",
                        //rowIdentifierColumnWidth: "12rem"
                    });

                    setAuditHistory(auditHistoryData);
                }
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error retrieving Raw Material Auditing Information");
            });
    }

    // GET functions

    async function getEntities() {
        await CrudFunctions.getData("common/entities")
            .then(data => {
                //temp for Phase 1
                let returnedEntities = data as Entity[]

                if (returnedEntities) {
                    const phase1Entities = ['AnalyticalPlans', 'Assets', 'BatchPlanning', 'BatchProductions', 'GasChromatographyAssets', 'Products', 'RawMaterials'];

                    const allEntities = returnedEntities.filter((i: any) =>
                        phase1Entities.includes(i.name)
                    );

                    setEntities(allEntities);
                }
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error retrieving Entities");
            });
    }

    // POST functions

    async function getProductUpdates(request: AuditHistoryRequest) {
        return await CrudFunctions.postData("auditing/fullproducthistory", request);
    }

    async function getRawMaterialUpdates(request: AuditHistoryRequest) {
        return await CrudFunctions.postData("auditing/fullrawmaterialhistory", request);
    }

    async function getBatchPlanningUpdates(request: AuditHistoryRequest) {
        return await CrudFunctions.postData("auditing/fullbatchplanninghistory", request);
    }
    async function getBatchProductionUpdates(request: AuditHistoryRequest) {
        return await CrudFunctions.postData("auditing/fullbatchproductionhistory", request);
    }



    /*
    async function getUpdates(request: AuditHistoryRequest) {
        return await CrudFunctions.postData("auditing/audithistorybyentityidfieldnameanddates", request);
    }
    */

    /*
    //render
 
    function auditDataToolbarTitleTemplateRender(e: any) {
        return (
            <div className="pw-datagrid-toolbar-template">
                <div className="pw-datagrid-toobar-title">Audit Data</div>
            </div>
        );
    }
 
    function renderEntity(data: Entity) {
        return <span>{data.label} ({data.description})</span>;
    }
    */



    async function getAllData() {
        await getEntities();
    }

    //other

    function setSearchLabels() {
        if (!entity)
            return;

        let idLabel = "";
        let nameLabel = "";

        //todo put this into db as metadata
        switch (entity.name) {
            case "Products":
                idLabel = "Product ID";
                nameLabel = "Catalog #";
                break;
            case "RawMaterials":
                idLabel = "Raw Material ID";
                nameLabel = "Raw Material Name";
                break;
            case "Batch Planning":
            case "Batch Production":
                idLabel = "Batch ID";
                nameLabel = "Batch Name";
                break;
            case "RawMaterialBatches":
                idLabel = "Raw Material Batch ID";
                nameLabel = "Raw Material Batch Name";
                break;
            case "Assets":
                idLabel = "Asset ID";
                nameLabel = "Asset Name";
                break;
        }

        setSearchIdLabel(idLabel);
        setSearchNameLabel(nameLabel);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function showReplyBox(mode: ModalMessageType, title: string, message: string) {
        let mm: ModalMetadata = {
            mode: mode,
            title: title,
            message: message
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function hideGlobalDialog() {
        setGlobalDialogVisible(false);
    }
}
